import cn from "classnames";
import { useState } from "react";

import styles from "./ExportResultsDialog.module.scss";

interface AccordionProps {
  name: string;
  _isExpanded?: boolean;
  children: React.ReactNode;
}

export default function Accordion(props: AccordionProps) {
  const [isExpanded, setIsExpanded] = useState(props._isExpanded ?? false);

  const rootClasses = cn(
    "usa-accordion",
    "sbs-usa-accordion",
    styles["accordion-root"]
  );

  const handleToggle = () => {
    setIsExpanded((prevValue) => !prevValue);
  };

  return (
    <div className={rootClasses}>
      <button
        role="button"
        className="usa-accordion__button"
        aria-expanded={isExpanded}
        onClick={handleToggle}
        aria-label={`${props.name} accordion button`}
      >
        {props.name}
      </button>

      {isExpanded && (
        <div className={cn("usa-accordion__content", styles["content"])}>
          {props.children}
        </div>
      )}
    </div>
  );
}
